<template>
    <div>
          <b-modal
              centered
              hide-footer
              v-model="modalExport"
              @close="onClose"
          >
              <template slot="modal-title">
                <div slot="header" class="bg-white border-0 ">
                  <div class="row align-items-center">
                    <div class="col-12">
                      <h3 class="mb-0">
                        นำเข้าไฟล์ตรวจสอบสถานะ
                      </h3>
                    </div>
                  </div>
                </div>
              </template>
              <template slot="default">
                  <div>
                      <base-input
                          formClasses="mb-0"
                          alternative
                          label="ข้อมูลประจำวันที่"
                          typeInput="date"
                          placeholder="dd/mm/yyyy"
                          size="lg"
                          v-model="search.date"  
                      />
                  </div>
                  <div class="mt-">
                      <label for=""><b>นำเข้าไฟล์</b></label>
                      <b-form-file v-model="fileImport" accept=".xls,.xlsx" plain @click="reset()" @change="onChange" ></b-form-file>
                  </div>
              </template>
          </b-modal>
      </div>
  </template>
  
  <script>
  import baseInput from '@/components/BaseInput.vue'
  export default {
      components: {
          baseInput
      },
      data () {
        return {
            fileImport: new File
        }
      },
      props: {
          modalExport: Boolean,
          search: Object,
      },
      methods: {
          onClose() {
              this.$emit('close', 'Import')
          }
      },
  }
  </script>